import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Checkbox,
  InputItem,
  Picker,
  Toast,
  Radio,
} from "antd-mobile-v2";
import "./index.less";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { createForm } from "rc-form";
import { GenderData } from "./const";
import { getQuestion } from "../../../public/getQuestion";
import { userInfoData } from "../../../public/getUserInfo";
import tool from "../../../api/tool";
import { post, get, postRaw } from "../../../api/service/services";
import allUrl from "../../../api/allUrl";
import sectioValue from "../../../api/service/secsstion";
const Item = List.Item;
class VerificationUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionData: [], // 密保问题数据
      userData: {},
      type: "forget",
    };
  }
  componentDidMount() {
    this.getQuestion();
    this.getuserInfoData();
  }
  // 获取用户信息
  getuserInfoData = async () => {
    let userData;
    let userCode = sectioValue.get("acount");
    if (!userCode) {
      this.setState({ type: "forget" });
      return;
    }
    userData = tool.get("userInfoData");
    if (!userData) {
      userData = await userInfoData();
    }
    this.setState({ userData: userData, type: "edit" });
  };
  // 获取密保问题数据
  getQuestion = async () => {
    let toolData = tool.get("questionData");
    // 判断密保问题数据有没有存，如果有就用已经存的，如果没有就重新请求
    if (toolData && toolData.length) {
      this.setState({ questionData: toolData });
      return;
    }
    let data = await getQuestion();
    tool.set("questionData", data);
    this.setState({ questionData: data });
  };
  // 数据提交
  onSubmit = () => {
    const { questionData, type } = this.state;
    this.props.form.validateFields({ force: true }, (error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      let questionName = questionData.filter((item) => {
        return item.value == values["pwdQuestionOne"][0];
      });
      values["pwdQuestionOne"] = questionName[0].label;
      if (type == "edit") {
        values["userCode"] = sectioValue.get("acount") || "";
      }
      this.requestSubmit(values);
    });
  };
  // 下一步接口请求
  requestSubmit = (data) => {
    const { submitData } = this.props;
    let newData = { ...data, verifyType: 1 };
    post(
      allUrl.register.passWordForget,
      {
        ...newData,
      },
      {
        "Content-Type": "application/json;charset=UTF-8",
      }
    )
      .then((res) => {
        if (res.code === 200 && res.success === true) {
          tool.set("validation", {
            type: "confidentiality", // 密保验证
            data: newData,
          });
          submitData();
        } else {
          Toast.info(res.msg, 1);
        }
      })
      .catch((err) => {
        Toast.info(
          err && err.data && err.data.msg ? err.data.msg : "提交失败",
          1
        );
      });
  };

  render() {
    const { value, userData, type } = this.state;
    const { getFieldProps, getFieldError } = this.props.form;
    let userCode = sectioValue.get("acount");
    return (
      <div className="wrap-verificationUser">
        <form>
          <List>
            <InputItem
              {...getFieldProps("userName", {
                initialValue:
                  userData && userData.userName ? userData.userName : "",
                rules: [{ required: true, message: "请输入真实姓名" }],
              })}
              clear
              error={!!getFieldError("userName")}
              onErrorClick={() => {
                alert(getFieldError("userName").join("、"));
              }}
              placeholder="请输入真实姓名"
              disabled={type == "edit" ? true : false}
            >
              姓名
            </InputItem>
            <WhiteSpace />
            <InputItem
              {...getFieldProps("idNumber", {
                initialValue:
                  userData && userData.idNumber ? userData.idNumber : "",
                rules: [
                  { required: true, message: "请输入证件号码" },
                  {
                    required: false,
                    pattern: new RegExp(
                      /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                      "g"
                    ),
                    message: "请输入正确的证件号码",
                  },
                ],
              })}
              disabled={type == "edit" ? true : false}
              clear
              labelNumber={8}
              error={!!getFieldError("idNumber")}
              onErrorClick={() => {
                alert(getFieldError("idNumber").join("、"));
              }}
              placeholder="请输入证件号码"
            >
              证件号码
            </InputItem>
            <Picker
              data={this.state.questionData}
              cols={1}
              {...getFieldProps("pwdQuestionOne", {
                initialValue: "",
                rules: [{ required: true, message: "请选择密保问题" }],
              })}
              title="选择密保问题"
            >
              <List.Item arrow="horizontal">密保问题</List.Item>
            </Picker>
            <WhiteSpace />
            <InputItem
              {...getFieldProps("pwdAnswerOne", {
                // initialValue: 'little ant',
                rules: [{ required: true, message: "请输入密保答案" }],
              })}
              clear
              error={!!getFieldError("pwdAnswerOne")}
              onErrorClick={() => {
                alert(getFieldError("pwdAnswerOne").join("、"));
              }}
              placeholder="请输入密保答案"
              labelNumber={8}
            >
              密保答案
            </InputItem>
            <div
              style={{
                height: "0.3rem",
                display: "flex",
                justifyContent: "flex-end",
                padding: "0 0.2rem",
                alignItems: "center",
              }}
            >
              {userCode ? (
                <p style={{ textDecoration: "underline", color: "#BBBBBC" }}>
                  <Link to="/editSecurity">忘记密保答案</Link>
                </p>
              ) : null}
            </div>

            <Item>
              <Button type="primary" onClick={this.onSubmit}>
                下一步
              </Button>
            </Item>
          </List>
        </form>
      </div>
    );
  }
}
export default createForm()(VerificationUser);
